(function () {
  'use strict';
  function setup() {
    var toggle = document.querySelector('[data-mobile-search-button]');
    var search = document.querySelector('[data-site-header-main] [data-live-search]');
    if (!toggle || !search || toggle.dataset.geSearchV2 === 'true') return;
    var input = search.querySelector('[data-live-search-input]');
    var cancel = search.querySelector('[data-live-search-takeover-cancel]');
    toggle.dataset.geSearchV2 = 'true';
    toggle.setAttribute('aria-expanded', 'false');
    function open(event) {
      if (!window.matchMedia('(max-width: 719px)').matches) return;
      if (event) { event.preventDefault(); event.stopImmediatePropagation(); }
      search.classList.add('ge-mobile-search-open', 'live-search--takeover');
      search.setAttribute('data-animation-state', 'open');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ge-mobile-search-lock');
      document.body.classList.add('mobile-search-takeover-active');
      window.setTimeout(function () { if (input) input.focus(); }, 80);
    }
    function close(event) {
      if (event) { event.preventDefault(); event.stopImmediatePropagation(); }
      search.classList.remove('ge-mobile-search-open', 'live-search--takeover');
      search.removeAttribute('data-animation-state');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ge-mobile-search-lock');
      document.body.classList.remove('mobile-search-takeover-active');
      if (input) input.blur();
    }
    toggle.addEventListener('click', open, true);
    if (cancel) cancel.addEventListener('click', close, true);
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && search.classList.contains('ge-mobile-search-open')) close(event); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
